import { render, staticRenderFns } from "./ModalWithoutTitle.vue?vue&type=template&id=6b8f5ce2&scoped=true&"
import script from "./ModalWithoutTitle.vue?vue&type=script&lang=js&"
export * from "./ModalWithoutTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithoutTitle.vue?vue&type=style&index=0&id=6b8f5ce2&lang=scss&scoped=true&"
import style1 from "./ModalWithoutTitle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f5ce2",
  null
  
)

export default component.exports